import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const SpecializationList = Loadable(
  lazy(() => import("features/specialization/components/List"))
);
const SpecializationPage = Loadable(
  lazy(() => import("features/specialization/components/Page"))
);

const routes = {
  path: "specialization",
  children: [
    { path: "", element: <SpecializationList /> },
    { path: "add", element: <SpecializationPage /> },
    { path: "edit/:specializationId?", element: <SpecializationPage /> },
  ],
};

export default routes;
